import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/common/layout/Layout";

Vue.use(VueRouter)

const routes = [
    {
        component: Layout,
        path: '/',
        children: [
            {
                path: '/',
                name: 'Home',
                component: () => import('../mainPage/mainPage.vue')
            },
            {
                path: '/user',
                name: 'UsersList',
                props: {mode: 'ShowActive'},
                component: () => import('../../user/UsersList.vue')
            },
            {
                path: '/user/archive',
                name: 'ArchiveUsersList',
                props: {mode: 'ShowInactive'},
                component: () => import('../../user/UsersList.vue')
            },
            {
                path: '/user/add',
                name: 'UserAdd',
                component: () => import('../../user/UserEdit.vue')
            },
            {
                path: '/user/myProfile',
                name: 'MyProfile',
                component: () => import('../../user/MyProfile.vue')
            },
            {
                path: '/user/myProfile/edit',
                name: 'MyProfileEdit',
                component: () => import('../../user/MyProfileEdit.vue')
            },
            {
                path: '/user/myProfile/changePassword',
                name: 'ChangeMyPassword',
                component: () => import('../../user/ChangeMyPassword.vue')
            },
            {
                path: '/user/staffTime',
                name: 'StaffTime',
                component: () => import('../../user/StaffTime.vue')
            },
            {
                path: '/user/report',
                name: 'UsersReport',
                component: () => import('../../user/UsersReport.vue')
            },
            {
                path: '/user/:id',
                name: 'UserShow',
                component: () => import('../../user/UserShow.vue')
            },
            {
                path: '/user/:id/edit',
                name: 'UserEdit',
                component: () => import('../../user/UserEdit.vue')
            },
            {
                path: '/user/:id/editPermissions',
                name: 'UserEdit',
                component: () => import('../../user/PermissionsEdit.vue')
            },
            {
                path: '/user/:id/changePassword',
                name: 'ChangeUsersPassword',
                component: () => import('../../user/ChangeUsersPassword.vue')
            },
            {
                path: '/attendanceLog',
                name: 'AttendanceLogList',
                component: () => import('../../biometricReader/AttendanceLogList.vue')
            },
            {
                path: '/biometricReader',
                name: 'BiometricReadersList',
                props: {mode: 'ShowActive'},
                component: () => import('../../biometricReader/BiometricReaderList.vue')
            },
            {
                path: '/biometricReader/archive',
                name: 'InactiveBiometricReadersList',
                props: {mode: 'ShowInactive'},
                component: () => import('../../biometricReader/BiometricReaderList.vue')
            },
            {
                path: '/biometricReader/add',
                name: 'BiometricReaderAdd',
                component: () => import('../../biometricReader/BiometricReaderEdit.vue')
            },
            {
                path: '/biometricReader/:id',
                name: 'BiometricReaderEdit',
                component: () => import('../../biometricReader/BiometricReaderInfo.vue')
            },
            {
                path: '/biometricReader/:id/edit',
                name: 'BiometricReaderEdit',
                component: () => import('../../biometricReader/BiometricReaderEdit.vue')
            },
            {
                path: '/location',
                name: 'LocationsList',
                props: {mode: 'ShowActive'},
                component: () => import('../../location/LocationsList.vue')
            },
            {
                path: '/location/archive',
                name: 'InactiveLocationsList',
                props: {mode: 'ShowInactive'},
                component: () => import('../../location/LocationsList.vue')
            },
            {
                path: '/location/add',
                name: 'LocationAdd',
                component: () => import('../../location/LocationsEdit.vue')
            },
            {
                path: '/location/sensors',
                name: 'LocationsSensors',
                component: () => import('../../location/LocationsSensors.vue')
            },
            {
                path: '/location/:id/edit',
                name: 'LocationEdit',
                component: () => import('../../location/LocationsEdit.vue')
            },
            {
                path: '/location/:id',
                name: 'LocationShow',
                component: () => import('../../location/LocationsShow.vue')
            },
            {
                path: '/competence',
                name: 'CompetencesList',
                props: {mode: 'ShowActive'},
                component: () => import('../../competence/CompetencesList.vue')
            },
            {
                path: '/competence/add',
                name: 'CompetenceAdd',
                component: () => import('../../competence/CompetenceEdit.vue')
            },
            {
                path: '/competence/:id/edit',
                name: 'CompetenceEdit',
                component: () => import('../../competence/CompetenceEdit.vue')
            },
            {
                path: '/competence/:id/remove',
                name: 'CompetenceRemove',
                component: () => import('../../competence/CompetenceRemove.vue')
            },
            {
                path: '/team',
                name: 'TeamsList',
                props: {mode: 'ShowActive'},
                component: () => import('../../schedule/TeamsList.vue')
            },
            {
                path: '/team/add',
                name: 'TeamAdd',
                component: () => import('../../schedule/TeamEdit.vue')
            },
            {
                path: '/team/:id/edit',
                name: 'TeamEdit',
                component: () => import('../../schedule/TeamEdit.vue')
            },
            {
                path: '/team/shaker/:locationId',
                name: 'TeamShaker',
                component: () => import('../../schedule/TeamShaker.vue')
            },
            {
                path: '/visualization/timeline',
                name: 'VisualizationTimeline',
                component: () => import('../../visualization/VisualizationTimeline.vue')
            },
            {
                path: '/clearanceSlip/tasks',
                name: 'ClearanceSlipTasks',
                component: () => import('../../clearanceSlip/ClearanceSlipTasks.vue')
            },
            {
                path: '/clearanceSlip/group',
                name: 'ClearanceSlipGroupList',
                component: () => import('../../clearanceSlip/ClearanceSlipGroupList.vue')
            },
            {
                path: '/clearanceSlip/group/add',
                name: 'ClearanceSlipGroupAdd',
                component: () => import('../../clearanceSlip/ClearanceSlipGroupEdit.vue')
            },
            {
                path: '/clearanceSlip/group/:id/edit',
                name: 'ClearanceSlipGroupEdit',
                component: () => import('../../clearanceSlip/ClearanceSlipGroupEdit.vue')
            },
            {
                path: '/clearanceSlip',
                name: 'ClearanceSlipList',
                props: {mode: 'all'},
                component: () => import('../../clearanceSlip/ClearanceSlipList.vue')
            },
            {
                path: '/clearanceSlip/my',
                name: 'ClearanceSlipListMy',
                props: {mode: 'my'},
                component: () => import('../../clearanceSlip/ClearanceSlipList.vue')
            },
            {
                path: '/clearanceSlip/add',
                name: 'ClearanceSlipAdd',
                component: () => import('../../clearanceSlip/ClearanceSlipEdit.vue')
            },
            {
                path: '/clearanceSlip/:id/edit',
                name: 'ClearanceSlipEdit',
                component: () => import('../../clearanceSlip/ClearanceSlipEdit.vue')
            },
            {
                path: '/clearanceSlip/:id',
                name: 'ClearanceSlipShow',
                component: () => import('../../clearanceSlip/ClearanceSlipShow.vue')
            },
            {
                path: '/clearanceSlip/:id/:supervisorId',
                name: 'ClearanceSlipShowDetails',
                component: () => import('../../clearanceSlip/ClearanceSlipShow.vue')
            },
            {
                path: '/schedule',
                name: 'ScheduleSummary',
                props: {mode: 'ShowActive'},
                component: () => import('../../schedule/ScheduleSummary.vue')
            },
            {
                path: '/schedule/replacement/',
                name: 'ReplacementsList',
                component: () => import('../../schedule/ReplacementsList.vue')
            },
            {
                path: '/schedule/replacement/create/:shiftID',
                name: 'createReplacement',
                component: () => import('../../schedule/CreateReplacement.vue')
            },
            {
                path: '/schedule/replacement/:id',
                name: 'ReplacementDetails',
                component: () => import('../../schedule/ReplacementDetails.vue')
            },
            {
                path: '/schedule/:shiftId/note/add',
                name: 'NoteAdd',
                component: () => import('../../schedule/NoteEdit.vue')
            },
            {
                path: '/schedule/note/add',
                name: 'NoteAdd',
                component: () => import('../../schedule/NoteEdit.vue')
            },
            {
                path: '/schedule/note/:noteId/edit',
                name: 'NoteEdit',
                component: () => import('../../schedule/NoteEdit.vue')
            },
            {
                path: '/schedule/:locationId/add',
                name: 'ShiftAdd',
                component: () => import('../../schedule/ShiftEdit.vue')
            },
            {
                path: '/schedule/shift/:id/edit',
                name: 'ShiftEdit',
                component: () => import('../../schedule/ShiftEdit.vue')
            },
            {
                path: '/schedule/:locationId/:date/edit',
                name: 'ScheduleEdit',
                component: () => import('../../schedule/ScheduleEdit.vue')
            },
            {
                path: '/schedule/:locationId/:date',
                name: 'ScheduleShow',
                component: () => import('../../schedule/ScheduleShow.vue')
            },
            {
                path: '/schedule/dayInfo',
                name: 'DayInfo',
                component: () => import('../../schedule/DayInfo.vue')
            },
            {
                path: '/mismatch',
                name: 'MismatchesList',
                component: () => import('../../analitycs/MismatchesList.vue')
            },
            {
                path: '/shiftReport/',
                name: 'UnsettledShiftsList',
                component: () => import('../../timechecker/NewAndNotFilled.vue')
            },
            {
                path: '/shiftReport/:shiftID',
                name: 'UnsettledShiftDetails',
                component: () => import('../../timechecker/ShiftReport.vue')
            },
            {
                path: '/leave/add',
                name: 'CreateLeaveRequest',
                component: () => import('../../leave/CreateLeaveRequest.vue')
            },
            {
                path: '/leave/addByManager',
                name: 'CreateLeaveRequest',
                component: () => import('../../leave/ManagerLeaveEdit.vue')
            },
            {
                path: '/leave',
                name: 'LeavesList',
                component: () => import('../../leave/LeavesList.vue')
            },
            {
                path: '/leave/calendar',
                name: 'LeavesList',
                component: () => import('../../leave/LeaveCalendar.vue')
            },
            {
                path: '/changeUser',
                name: 'ChangeUser',
                component: () => import('../../changeUser/ChangeUser.vue')
            },
            {
                path: '/leave/:id',
                name: 'LeaveDetails',
                component: () => import('../../leave/LeaveDetails.vue')
            },
            {
                path: '/leave/:id/edit',
                name: 'ManagerLeaveEdit',
                component: () => import('../../leave/ManagerLeaveEdit.vue')
            },
            {
                path: '/leave/:id/requestEdit',
                name: 'LeaveRequestEdit',
                component: () => import('../../leave/CreateLeaveRequest.vue')
            },
            {
                path: '/workersAvailability',
                name: 'WorkersAvailabilityList',
                component: () => import('../../workersAvailability/WorkersAvailabilityList.vue')
            },
            {
                path: '/workersAvailability/add',
                name: 'WorkersAvailabilitySlotAdd',
                component: () => import('../../workersAvailability/WorkersAvailabilitySlotEdit.vue')
            },
            {
                path: '/workersAvailability/request',
                name: 'WorkersAvailabilityRequest',
                component: () => import('../../workersAvailability/WorkersAvailabilityRequest.vue')
            },
            {
                path: '/workersAvailability/:id/edit',
                name: 'WorkersAvailabilitySlotEdit',
                component: () => import('../../workersAvailability/WorkersAvailabilitySlotEdit.vue')
            },
            {
                path: '/workersAvailability/:id',
                name: 'WorkersAvailabilitySlot',
                component: () => import('../../workersAvailability/WorkersAvailabilitySlot.vue')
            },
            {
                path: '/disk',
                name: 'DiskList',
                component: () => import('../../disk/DiskList.vue')
            },
            {
                path: '/disk/addDirectory',
                name: 'DirectoryAdd',
                component: () => import('../../disk/DirectoryEdit.vue')
            },
            {
                path: '/disk/directory/:parentId/addSubdirectory',
                name: 'SubdirectoryAdd',
                component: () => import('../../disk/DirectoryEdit.vue')
            },
            {
                path: '/disk/directory/:id',
                name: 'DiskList',
                component: () => import('../../disk/DiskList.vue')
            },
            {
                path: '/disk/directory/:id/edit',
                name: 'DirectoryEdit',
                component: () => import('../../disk/DirectoryEdit.vue')
            },
            {
                path: '/disk/file/:id/edit',
                name: 'DiskFileEdit',
                component: () => import('../../disk/DiskFileEdit.vue')
            },
            {
                path: '/disk/file/:id',
                name: 'DiskFileShow',
                component: () => import('../../disk/DiskFileShow.vue')
            },
            {
                path: '/log',
                name: 'ListLogItems',
                component: () => import('../../common/log/ListLogItems.vue')
            },
            {
                path: '/viewed',
                name: 'ViewsLog',
                component: () => import('../../common/log/ViewsLog.vue')
            },
            {
                path: '/viewed/combined',
                name: 'ViewsLogCombined',
                component: () => import('../../common/log/ViewsLogCombined.vue')
            },
            {
                path: '/log/:id',
                name: 'ListLogItems',
                component: () => import('../../common/log/LogItemDetails.vue')
            },
            {
                path: '/commission',
                name: 'CommissionProductList',
                component: () => import('../../commission/CommissionProductList.vue')
            },
            {
                path: '/commissionProduct/add',
                name: 'CommissionProductAdd',
                component: () => import('../../commission/CommissionProductEdit.vue')
            },
            {
                path: '/commissionProduct/:id',
                name: 'CommissionProductShow',
                component: () => import('../../commission/CommissionProductShow.vue')
            },
            {
                path: '/commissionProduct/:id/edit',
                name: 'CommissionProductEdit',
                component: () => import('../../commission/CommissionProductEdit.vue')
            },
            {
                path: '/evaluation/',
                name: 'EvaluationList',
                component: () => import('../../evaluation/EvaluationList.vue')
            },
            {
                path: '/evaluation/questions',
                name: 'EvaluationQuestionsEdit',
                component: () => import('../../evaluation/EvaluationQuestionsEdit.vue')
            },

            {
                path: '/evaluation/:id/polls',
                name: 'EvaluationPollsList',
                component: () => import('../../evaluation/EvaluationPollsList.vue')
            },
            {
                path: '/evaluation/:id/report',
                name: 'EvaluationReport',
                component: () => import('../../evaluation/EvaluationReport.vue')
            },
            {
                path: '/evaluation/poll/:id',
                name: 'EvaluationPollDetails',
                component: () => import('../../evaluation/EvaluationPollDetails.vue')
            },
            {
                path: '/evaluation/add',
                name: 'EvaluationAdd',
                component: () => import('../../evaluation/EvaluationEdit.vue')
            },
            {
                path: '/evaluation/:id/edit',
                name: 'EvaluationEdit',
                component: () => import('../../evaluation/EvaluationEdit.vue')
            },
            {
                path: '/comments/:objectType/:objectID',
                name: 'EvaluationEdit',
                component: () => import('../../comment/Comments.vue')
            },
            {
                path: '/communication/sendMessage',
                name: 'EvaluationEdit',
                component: () => import('../../communication/SendMessage.vue')
            },
            {
                path: '/support',
                name: 'Support',
                component: () => import('../../common/Support.vue')
            },
        ]
    },
    {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import('../../authorization/ResetPassword.vue')
    },
    {
        path: '/resetPassword/:token',
        name: 'resetPassword2',
        component: () => import('../../authorization/ResetPassword2.vue')
    },
    {
        path: '*',
        name: 'error404',
        // component: () => import('mpts-vue-loader!../layout/Error404.mpts')
        component: () => import('../layout/Error404')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,

})

export default router
